import { cn, titleCase } from '@/lib/utils'
import type { CallWaypoint } from '@/features/calls/types'

export function WaypointRow({
  waypoints,
  className,
}: {
  waypoints: CallWaypoint[]
  className?: string
}) {
  if (waypoints.length === 0) return null

  return (
    <div className={cn('px-6 py-3 max-w-[600px]', className)}>
      {waypoints.map((wp, i) => {
        const isLast = i === waypoints.length - 1
        return (
          <div key={i} className="flex items-start gap-3">
            {/* Dot + line */}
            <div className="flex flex-col items-center shrink-0 mt-1">
              <div className="h-2 w-2 rounded-full bg-indigo-400" />
              {!isLast && (
                <div className="w-px flex-1 bg-slate-200 min-h-[16px]" />
              )}
            </div>
            {/* Label + reason */}
            <div className={isLast ? 'pb-0' : 'pb-3'}>
              <span className="text-xs font-medium text-slate-700">
                {titleCase(wp.name ?? wp.step ?? '')}
              </span>
              {wp.reason && (
                <span className="text-xs text-slate-400">
                  {' — '}
                  {wp.reason}
                </span>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}
